import SwitchInput from './switch_input';

export {
    SwitchInput
};